import { t } from "@/i18n-js/instance";
import type {
  PaywallCheckoutPreview,
  PaywallPriceScenario,
} from "@circle-react/types";
import type { StatusBadgeProps } from "@circle-react-shared/uikit/StatusBadge";
import { StatusBadge } from "@circle-react-shared/uikit/StatusBadge";

interface PreviewBadgeProps {
  preview: PaywallCheckoutPreview;
}

interface StatusBadgeProperty {
  label: string;
  variant: StatusBadgeProps["variant"];
}

const statusBadgeProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    label: t("free_trial"),
    variant: "info",
  },
  trial_then_upfront_then_value: {
    label: t("free_trial"),
    variant: "info",
  },
  upfront_then_trial_then_value: {
    label: t("paid_trial"),
    variant: "default",
  },
  value: null,
  upfront_then_value: null,
};

export const PreviewBadge = ({ preview }: PreviewBadgeProps) => {
  const property = statusBadgeProperties[preview.preview_scenario];

  if (property) {
    return (
      <StatusBadge variant={property.variant}>{property.label}</StatusBadge>
    );
  }

  return null;
};
